import { render } from "./DatePickerSimple.vue?vue&type=template&id=382dff2c&scoped=true"
import script from "./DatePickerSimple.vue?vue&type=script&lang=js"
export * from "./DatePickerSimple.vue?vue&type=script&lang=js"

import "./DatePickerSimple.vue?vue&type=style&index=0&id=382dff2c&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382dff2c"]])

export default __exports__